import { color } from "@styles";
import { mobile, tablet } from "components/templates/Breakpoints";
import styled from "styled-components";
import { StandardSection } from "components/templates/StandardSection";
import Image from "next/image";

export const Img = styled.img`
  max-width: 34rem;

  ${tablet} {
    width: 100%;
  }
`;

export const ProductOverviewSectionCopy = styled(StandardSection)`
  padding-bottom: 3.5rem;
  padding-top: 0rem;
`;

export const ProductOverviewSection = styled.div`
  padding-left: 3rem;
  padding-right: 3rem;
`;

export const ProductCardsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  row-gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  max-width: 81rem;
  margin: 0 auto;
  padding-bottom: 1rem;
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 8rem;
  display: flex;
  justify-content: center;
  background: ${color.B210};
`;

export const YuCoinImg = styled(Image)`
  position: absolute;
  right: 3rem;

  @media only screen and (max-width: 70rem) {
    display: none;
  }
`;

export const GuardianImg = styled(Image)`
  margin: 0 5rem 0 5rem;

  ${tablet} {
    display: none;
  }
`;

export const CenteredButtonWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 5rem 0 2rem;

  ${mobile} {
    padding-bottom: 4rem;
  }
`;
